/**
 * @fileoverview Clothing theme - match clothing and accessory emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Clothing theme with clothes and accessories.
 */
export class ClothingTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'clothing',
            'Clothing',
            allLabels.clothing,
            { numPairs: 4, isPremium: false, hasMovement: false, ...options }
        );
    }
}
